/**
 * PATH: packages/email-hub/src/feature/components/email-context-menu/EmailContextMenuDialogs.tsx
 * FILE_ID: EMAILHUB-CONTEXTMENU-DIALOGS-001
 * PURPOSE: Persistent dialogs launched by ephemeral context-menu actions.
 * WHY: Keeps dialog lifecycles mounted after the right-click menu closes.
 */
import { CreateBoardDialog } from '@quotech/ui/kanban'

import LinkToJobModal from '../LinkToJobModal'
import { RequestRuleDialog } from '../RequestRuleDialog'
import type { EmailContextMenuController } from './useEmailContextMenuController'

export function EmailContextMenuDialogs({
  controller,
}: {
  controller: EmailContextMenuController
}) {
  const {
    createBoardFor,
    handleCreateBoardAndAllocate,
    kanbanApi,
    linkModal,
    onRefetch,
    orgId,
    requestRuleFor,
    setCreateBoardFor,
    setLinkModal,
    setRequestRuleFor,
  } = controller

  return (
    <>
      {linkModal && (
        <LinkToJobModal
          emailId={linkModal.emailId}
          emailSubject={linkModal.emailSubject}
          emailBody={linkModal.emailBody}
          emailFrom={linkModal.emailFrom}
          isOpen
          onClose={() => setLinkModal(null)}
          onLinked={onRefetch}
        />
      )}
      {createBoardFor && orgId != null && (
        <CreateBoardDialog
          open
          onClose={() => setCreateBoardFor(null)}
          organisationId={orgId}
          onCreate={handleCreateBoardAndAllocate}
          loadTemplateCandidates={async () =>
            kanbanApi.listBoards({ organisationId: orgId })
          }
        />
      )}
      {requestRuleFor && orgId != null && (
        <RequestRuleDialog
          api={kanbanApi}
          orgId={orgId}
          emailId={requestRuleFor.emailId}
          senderAddress={requestRuleFor.senderAddress}
          category={requestRuleFor.category}
          onClose={() => setRequestRuleFor(null)}
          onApplied={onRefetch}
        />
      )}
    </>
  )
}
